import { useQuery } from '@tanstack/react-query';
import * as Mappers from '../mappers';
import * as Queries from '../queries';
import * as Types from '../types';
import { keepPageWithinOrg } from './keepPageWithinOrg';

interface IProps {
  params?: Types.IApi.List.Params;
  enabled?: boolean;
}

const useList = ({ params, enabled = true }: IProps = {}) => {
  const initialData = { items: [], meta: Mappers.Meta() } as Types.IQuery.List;

  const { data = initialData, ...args } = useQuery<Types.IQuery.List>({
    queryKey: ['test', 'list', JSON.stringify(params)],
    placeholderData: keepPageWithinOrg(params),
    queryFn: Queries.List({ params })[1],
    enabled,
  });

  return { ...args, ...data };
};

export default useList;
